import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";
import {connect, useDispatch} from "react-redux";
import {Header, Icon, Button, Modal, Form, Dimmer, Loader, Message} from "semantic-ui-react";
import {
  MFAContainer
} from "../styled";
import {MFA_TYPE} from "../constants";
import {MfaMethodItem} from "./mfaMethodItem";
import {ConfirmChangeMethodModal} from "./confirmChangeMethodModal";
import {MFA_ROUTE, resolveErrorMessage} from "../../utils/common";
import {show as showToast} from "../../actions/toastActions";
import {CustomContainer, CustomDivider, CustomGrid, CustomModalHeader} from "../../components/custom-common";

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    mfaEmailSetUpped: state.auth?.mfaEmailSetUpped,
  }
}


const MfaSettingsReminder = ({ setUpMfa }) => {
  return (
    <>
      <CustomDivider small hidden/>
      <CustomContainer basic padded className={"small noVerticalMargin bkgNeutral50"}>
        Two-factor authentication is an additional layer of security for your
        account. In addition to your normal credentials, you'll also need to
        provide an authentication code when logging in.
      </CustomContainer>
      <CustomDivider small hidden/>
      <CustomDivider small hidden/>
      <Button primary onClick={setUpMfa}>
        Set up two-factor authentication
      </Button>
    </>
  );
};

export const MfaSettings = ({ mfaEnabled, setLeftNavigation, getMfaSettings, formatDate, generateBackupCodes, mfaEmailSetUpped }) => {
  const [mfaMethods, setMfaMethods] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const [backupCodeGeneratedTime, setBackupCodeGeneratedTime] = useState(null);
  const [showWarnBackupCodes, setShowWarnBackupCodes] = useState(false);
  const [showReConfigureMethod, setShowReConfigureMethod] = useState(false);
  const [showBackupCodes, setShowBackupCodes] = useState(false);
  const [mfaSavedCodes, setMfaSavedCodes] = useState(false);
  const [backupCodes, setBackupCodes] = useState(null);
  const [methodToChange, setMethodToChange] = useState(null);
  const [showChangeMethodModal, setShowChangeMethodModal] = useState(false)

  const history = useHistory();
  const dispatch = useDispatch();

  const setUpMfa = () => {
    dispatch(setLeftNavigation(false));
    history.push({ pathname: "/mfa", state: { setupMfaFromSettings: true }});
  };

  const printCodes = () => {

    // Format the date as "MM-DD-YYYY"
    const formattedDate = formatDate(new Date(), null, 'MM-DD-YYYY');

    // Set the filename with the formatted date
    var filename = `Backup codes ${formattedDate}`;

    var divContents = document.getElementById("backUpCodes").innerHTML;
    var a = window.open("", "", "height=250, width=500");
    a.document.write("<html>");
    a.document.write(`<head><title>${filename}</title></head>`);
    a.document.write("<body> <h1>Backup Codes</h1> <br />");
    a.document.write(divContents);
    a.document.write("</body></html>");
    a.document.close();
    a.print();
  };

  const copyToClipboard = async () => {
    const formattedBackupCodes = backupCodes.join('\n');
    try {
      await navigator.clipboard.writeText(formattedBackupCodes);
      showToastSuccess();
    } catch (error) {
      showToastError();
    }
  }

  const showToastSuccess = () => {
    dispatch(showToast({
      type: 'success',
      title: "Copy backup codes",
      message: "Backup codes copied to clipboard.",
    }))
  }

  const showToastError = () => {
    dispatch(showToast({
      type: 'error',
      title: "Copy backup codes",
      message: "Unable to copy backup codes. Please try again.",
    }))
  }

  const regenerateBackupCodes = async () => {
    setShowWarnBackupCodes(false);
    setMfaSavedCodes(false);
    setBackupCodes(null);

    try {
      const response = await generateBackupCodes();
      setBackupCodes(response.data.backupCodeList);
      setShowBackupCodes(true);
    } catch (error) {
      dispatch(showToast({
        type: 'error',
        title: "Backup codes",
        message: "Unable to regenerate backup codes. Please try again.",
      }))
      console.log('error: ', error);
    }
  };

  const reConfigureMethod = async () => {
    setShowReConfigureMethod(false);
    history.push({ pathname: '/mfa', state: { changeMethod: methodToChange }});
  };

  const onCloseChangeMethodModal = () => setShowChangeMethodModal(false)

  const handleSubmitChangeMethodModal = () => {
    setShowChangeMethodModal(false)
    let changeMethod = ''
    if (mfaMethods?.totpKey?.active) changeMethod = MFA_TYPE.TOTP
    if (mfaMethods?.email?.active) changeMethod = MFA_TYPE.EMAIL
    setShowReConfigureMethod(false);
    history.push({ pathname: MFA_ROUTE, state: { changeMethod }});
  }

  const openhangeMethodModal = () => setShowChangeMethodModal(true)

  const getMFAInfo = async () => {
    setLoading(true);
    setLoadError(null);
    await getMfaSettings()
      .then(async (response) => {
        setBackupCodeGeneratedTime(response.data.backupCodeGeneratedTime)
        setMfaMethods(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoadError(resolveErrorMessage(error, "Unable to load two-factor authentication settings."));
        setLoading(false);
      });
  };

  useEffect(() => {
    getMFAInfo();
  }, []);

  const cardTitle = mfaEnabled
    ? "Two-factor authentication"
    : "Set up two-factor authentication";

  const renderContent = () => {
    if (!mfaEnabled) {
      return <MfaSettingsReminder setUpMfa={setUpMfa} />;
    }

    if (loadError) {
      return <Message negative>{loadError}</Message>;
    }

    return <>
        <CustomDivider small hidden/>
        <div className={'small neutral700Text'}>
          Your account is more secure with two-factor authentication.
        </div>
        <CustomContainer basic className={'mfaSettingsEnable'}>
          <Icon
              name="checkmark"
              size="small"
              className={'mfaVerifiedIcon'}
          />{" "}
          <p className={'small'}><b>Two-factor authentication is enabled in your account.</b></p>
        </CustomContainer>

        {mfaMethods.totpKey?.active && (
            <MfaMethodItem
                title="Authenticator app"
                description="Authenticator app"
                createdTime={formatDate(mfaMethods.totpKey?.createdTime)}
                ableToBeReconfigured={false}
            />
        )}

        {mfaMethods?.email?.active && (
            <MfaMethodItem
                title="Email"
                description={mfaEmailSetUpped}
                createdTime={formatDate(mfaMethods.email?.createdTime)}
                ableToBeReconfigured={false}
            />
        )}

        <div className={'mfaSectionDivider'}>
          <CustomGrid className={'mfaBackupCodesGrid'}>
            <CustomGrid.Row columns={2}>
              <CustomGrid.Column floated={'left'}>
                <div className={"neutral700Text"}>
                  <b> Backup codes </b>
                </div>
                <CustomDivider smaller hidden/>
                <p className={"smaller neutral700Text"}>
                  You will need these backup codes if you ever lose access to
                  your authentication method. Each code may be used only once.<br/>
                  <i>Last generated on {formatDate(backupCodeGeneratedTime)}</i>
                </p>
              </CustomGrid.Column>
              <CustomGrid.Column floated={'right'} className={'mfaFlexEnd'}>
                <Button basic compact fluid
                        primary
                        onClick={() => {
                          setShowWarnBackupCodes(true);
                        }}
                        className={'mfaRegenerateButton'}
                >
                  <span style={{whiteSpace: 'nowrap'}}>
                    <span style={{marginRight: 8}}>
                      Regenerate
                    </span>
                    <Icon
                        name={"redo"}
                        floated={"right"}
                    />
                  </span>
                </Button>
              </CustomGrid.Column>
            </CustomGrid.Row>
          </CustomGrid>
        </div>
        <div className={'mfaSectionDivider'}
             style={{paddingBottom:0}}>
          <Button fluid primary
              onClick={openhangeMethodModal}
          >
            Change method
          </Button>
        </div>
      </>;
  };

  return (
    <>
      <CustomContainer padded>
        <Header as="h4">
          {cardTitle}
        </Header>
        <Dimmer.Dimmable dimmed={loading}>
          <div className={'mfaSettingsContent'}>
            {loading ? null : renderContent()}
          </div>
          <Dimmer active={loading} inverted><Loader active/></Dimmer>
        </Dimmer.Dimmable>
      </CustomContainer>
      <ConfirmChangeMethodModal
          onClose={onCloseChangeMethodModal}
        displayModal={showChangeMethodModal}
        submit={handleSubmitChangeMethodModal}
      />

      <Modal
        style={{width: '525px', maxWidth: '95%'}}
        onClose={() => {
          setShowWarnBackupCodes(false);
        }}
        open={showWarnBackupCodes}
      >
        <CustomModalHeader title={'Are you sure you want to regenerate backup codes?'}
                            onClose={() => setShowWarnBackupCodes(false)}
                            className={"customModalHeader"}/>

        <Modal.Content padded>
          <p className={'small'}>
            Generating new codes will invalidate the previous set you have
            <br /> generated.
          </p>
          <CustomDivider medium hidden/>
          <div style={{textAlign: 'right'}}>
            <Button basic
                onClick={() => {
                  setShowWarnBackupCodes(false);
                }}
                className={"grey"}
            >
              {"Cancel"}
            </Button>
            <Button primary onClick={() => regenerateBackupCodes()}>
              {"Continue"}
            </Button>
          </div>
        </Modal.Content>
      </Modal>
      <Modal
       size={"small"} style={{maxWidth: '570px'}}
        onClose={() => {
          setShowReConfigureMethod(false);
        }}
        open={showReConfigureMethod}
      >
        <CustomModalHeader title={'Are you sure you want to re-configure your authenticator app?'}
                           onClose={() => {
                             setShowReConfigureMethod(false);
                           }}/>
        <Modal.Content>
          <p className={'small'}>
            Re-configuring your authentication will invalidate your previous
            authentication
            <br/> method.
          </p>
          <CustomDivider medium hidden/>
          <div style={{textAlign: 'right'}}>
            <Button basic
                onClick={() => {
                  setShowReConfigureMethod(false);
                }}
                className={"grey"}
            >
              {"Cancel"}
            </Button>
            <Button primary onClick={() => reConfigureMethod()}>
              {"Continue"}
            </Button>
          </div>
        </Modal.Content>
      </Modal>
      <Modal
        size={"small"}
        open={showBackupCodes}
        style={{maxWidth: '650px'}}
      >
        <CustomModalHeader title={'Backup codes'}
                           isCloseVisible={false}/>
        <Modal.Content style={{height: "450px"}} className={"small"}>
          <p className={'small'}>
            You will need these backup codes if you ever lose access to your
            authentication method. Each code may be used only once. Make sure
            you save a copy somewhere safe.
          </p>
          <CustomDivider medium hidden/>
          <MFAContainer className="sectionWrapper" maxWidth={"620px"}>
            <CustomGrid>
              <CustomGrid.Row>
                <CustomGrid.Column>
                  <CustomContainer basic textAlign={'center'}>
                    <CustomGrid.Row>
                      <CustomGrid.Column>
                        <CustomGrid
                          columns={5}
                          id="backUpCodes"
                          className={'bkgNeutral100'}
                          compact={'horizontally'}
                        >
                          {backupCodes?.map((item, index) => {
                            return (
                              <CustomGrid.Column key={index} className={'small'}>
                                {item}
                              </CustomGrid.Column>
                            );
                          })}
                        </CustomGrid>
                      </CustomGrid.Column>
                    </CustomGrid.Row>
                    <CustomGrid.Row>
                      <CustomGrid.Column>
                        <MFAContainer className={"backupCodeWrapper"}>
                          <div className={'mfaButtonsContainer'}>
                            <Button basic primary
                                onClick={() => {
                                  if (backupCodes) {
                                    copyToClipboard();
                                  }
                                }}
                            >
                              Copy
                            </Button>
                            <Button basic primary
                                onClick={() => {
                                  if (backupCodes) {
                                    printCodes();
                                  }
                                }}
                                className={"printBtn"}
                            >
                              Print
                            </Button>
                          </div>
                        </MFAContainer>
                      </CustomGrid.Column>
                    </CustomGrid.Row>
                    <CustomGrid.Row>
                      <CustomGrid.Column>
                        <Form >
                          <Form.Checkbox
                            label={`I've saved my backup codes`}
                            name="savedCodes"
                            id="savedCodes"
                            checked={mfaSavedCodes}
                            onChange={(_, data) =>
                              setMfaSavedCodes(!!data.checked)
                            }
                          />
                        </Form>
                      </CustomGrid.Column>
                    </CustomGrid.Row>
                  </CustomContainer>
                </CustomGrid.Column>
              </CustomGrid.Row>
            </CustomGrid>
          </MFAContainer>
          <CustomContainer basic className={'mfaCloseBackupContent'} textAlign={'center'}>
            <Button primary
                onClick={() => {
                  setShowBackupCodes(false);
                }}
                disabled={!mfaSavedCodes}
            >
              {"Close"}
            </Button>
          </CustomContainer>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default connect(mapStateToProps)(MfaSettings);
